import "./hero.scss";
import estIcon from "../../assets/icons/est.svg";
import yrIcon from "../../assets/icons/yr2k19.svg";
import asterisk from "../../assets/images/asterisk.svg";
import asteriskRotated from "../../assets/images/asterisk-rotated.svg";

function Hero() {
  return (
    <div className="hero">
      <h1 className="hero__title">
        Basement
        <br />
        <span className="hero__title-bottom">
          <img
            className="hero__title-bottom__img"
            src={estIcon}
            alt="EST in an oval"
          />
          <span className="hero__title-bottom__text">Supply</span>
          <img
            className="hero__title-bottom__img"
            src={yrIcon}
            alt="2K19 in an oval"
          />
        </span>
      </h1>
      <img className="asterisk asterisk-reg" src={asterisk} alt="3D asterisk" />
      <img
        className="asterisk asterisk-turn"
        src={asteriskRotated}
        alt="3D asterisk rotated"
      />
    </div>
  );
}

export default Hero;
